"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var _Panel = _interopRequireDefault(require("../../../panel/Panel/Panel"));

var _antd = require("antd");

var _deviceUnits = require("../../../../core/deviceUnits");

require("./Window.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["expanded", "collapsible", "expandDir", "preTools", "postTools", "style", "title", "onOk", "onCancel", "onClose", "visible"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * 
 * The Window Component
 */
var Window = function Window(_ref) {
  var _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? true : _ref$expanded,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? true : _ref$collapsible,
      expandDir = _ref.expandDir,
      _ref$preTools = _ref.preTools,
      preTools = _ref$preTools === void 0 ? undefined : _ref$preTools,
      _ref$postTools = _ref.postTools,
      postTools = _ref$postTools === void 0 ? undefined : _ref$postTools,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Untitled' : _ref$title,
      _ref$onOk = _ref.onOk,
      onOk = _ref$onOk === void 0 ? undefined : _ref$onOk,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? undefined : _ref$onCancel,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? undefined : _ref$onClose,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  //if(!visible) return null;
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      bounds = _useState2[0],
      setBounds = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      dragDisabled = _useState4[0],
      setDragDisabled = _useState4[1];

  var draggleRef = (0, _react.useRef)(null);
  var onStart = (0, _react.useCallback)(function (event, uiData) {
    var _window, _window$document, _draggleRef$current;

    var _window$document$docu = (_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.documentElement,
        clientHeight = _window$document$docu.clientHeight;

    var targetRect = draggleRef === null || draggleRef === void 0 ? void 0 : (_draggleRef$current = draggleRef.current) === null || _draggleRef$current === void 0 ? void 0 : _draggleRef$current.getBoundingClientRect();
    setBounds({
      //left: -targetRect?.left + uiData?.x,
      //right: clientWidth - (targetRect?.right - uiData?.x),
      top: -(targetRect === null || targetRect === void 0 ? void 0 : targetRect.top) + (uiData === null || uiData === void 0 ? void 0 : uiData.y),
      //bottom: clientHeight -  (targetRect?.bottom - uiData?.y)
      //bottom: 1.10*clientHeight - (targetRect?.bottom - uiData?.y),
      bottom: clientHeight - (0, _deviceUnits.convertRemToPixels)(20)
    });
  }, []);
  /*
  const onStart = useCallback((event, uiData) => {
      const { clientWidth, clientHeight } = window?.document?.documentElement;
      const targetRect = draggleRef?.current?.getBoundingClientRect();
      setBounds({
          left: -targetRect?.left + uiData?.x,
          right: clientWidth - (targetRect?.right - uiData?.x),
          top: -targetRect?.top + uiData?.y,
          bottom: clientHeight - (targetRect?.bottom - uiData?.y),
          //bottom: 1.10*clientHeight - (targetRect?.bottom - uiData?.y),
        },);
  },[]);
  */

  /**
   * Handler to enable dragging if the mouse is 
   * over the Title Bar.
   */

  var onTitleMouseOver = (0, _react.useCallback)(function () {
    setDragDisabled(false);
  }, []);
  /**
   * Handler to disable dragging if the mouse is 
   * out of the Title Bar.
   */

  var onTitleMouseOut = (0, _react.useCallback)(function () {
    setDragDisabled(true);
  }, []);
  return visible && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "rolext-wnd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDraggable.default, {
      nodeRef: draggleRef,
      disabled: dragDisabled,
      bounds: bounds,
      onStart: onStart,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: draggleRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Space, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Panel.default, {
            title: title,
            expanded: expanded,
            collapsible: true,
            style: style,
            preTools: preTools,
            postTools: postTools,
            expandDir: expandDir,
            onTitleMouseOver: onTitleMouseOver,
            onTitleMouseOut: onTitleMouseOut,
            titleStyle: {
              width: '100%',
              cursor: 'move'
            },
            onClose: onClose,
            children: [otherProps.children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Divider, {
              style: {
                margin: "5px"
              }
            }), (onOk || onCancel) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "rolext-wnd-btn-container",
              children: [onOk && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
                type: "primary",
                onClick: onOk,
                children: "OK"
              }), onCancel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Button, {
                type: "primary",
                onClick: onCancel,
                children: "Cancel"
              })]
            })]
          })
        })
      })
    })
  });
};

Window.propTypes = {
  /**
   * Set to true by default. 
   * Passing expanded as false will show the 
   * window panel collapsed.
   */
  expanded: _propTypes.default.bool,

  /**
   * If true, the window titlebar will display 
   * a collapse/expand control to collapse/expand the window panel.
   */
  collapsible: _propTypes.default.bool,

  /**
   * Not used currently.
   * To be used in the future to allow to expand in a horizontal
   * direction.
   * @ignore
   */
  expandDir: _propTypes.default.string,

  /**
   * Arbitrary tools, any element or React component you’d like, 
   * to be shown in the titlebar before the collapse/expand control.
   */
  preTools: _propTypes.default.node,

  /**
   * Arbitrary tools, any element or React component you’d like, 
   * to be shown in the titlebar, after the close control.
   */
  postTools: _propTypes.default.node,

  /**
   * A CSS Style to render the Window
   */
  style: _propTypes.default.object,

  /**
   * a title to be shown in the Window titlebar
   */
  title: _propTypes.default.node.isRequired,

  /**
   * A callback function to be called once the
   * user clicks in the <i>OK</i> button.
   * If null, the <i>OK</i> button will not be 
   * shown.
   */
  onOk: _propTypes.default.func,

  /**
  * A callback function to be called once the
  * user clicks in the <i>Cancel</i> button.
  * If null, the <i>Cancel</i> button will not be 
  * shown.
  */
  onCancel: _propTypes.default.func,

  /**
  * A callback function to be called once the
  * user clicks in the close control.
  * If null, the close control will not be 
  * shown.
  */
  onClose: _propTypes.default.func
};
var _default = Window;
exports.default = _default;